// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"6eb780cf","459":"42f42de8","774":"de545858"}[chunkId] + ".chunk.js";
};